import React, { Suspense } from 'react';

import { ErrorBoundary } from './ErrorBoundary';

function universal(load) {
  const Cmp = React.lazy(load);
  return (props) => (
    <ErrorBoundary contentTypeId={props.contentTypeId}>
      {/** * Showing a loading animation of all of these is distracting and looks
      * buggy. Instead just leave it empty with 0 height. It's rare that this *.
      will actually be rendered for more than a fraction of a second. */}
      <Suspense fallback={<></>}>
        <Cmp {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}

export const Anchor = universal(() => import('./Anchor'));
export const Beliefs = universal(() => import('./Beliefs'));
export const Buzz = universal(() => import('./Buzz'));
export const Callout = universal(() => import('./Callout'));
export const ComposableCallout = universal(() => import('./ComposableCallout'));
export const CorporateProductHero = universal(() =>
  import('./CorporateProductHero')
);
export const DailyBurn = universal(() => import('./DailyBurn'));
export const DidYouKnow = universal(() => import('./DidYouKnow'));
export const GameForm = universal(() => import('./GameForm'));
export const Html = universal(() => import('./Html'));
export const DownloadHero = universal(() => import('./DownloadHero'));
export const Feature = universal(() => import('./Feature'));
export const FeaturedGames = universal(() => import('./FeaturedGames'));
export const FeaturedGamesCarousel = universal(() =>
  import('./FeaturedGamesCarousel')
);
export const FinishRegistration = universal(() =>
  import('./FinishRegistration')
);
export const GameApps = universal(() => import('./GameApps'));
export const Checkout = universal(() => import('./Checkout'));
export const GameDetailScreenV2 = universal(() =>
  import('./GameDetailScreenV2')
);
export const GameDetailScreenV3 = universal(() =>
  import('./GameDetailScreenV3')
);
export const GameDetail = universal(() => import('./GameDetail'));
export const GameDirectory = universal(() => import('./GameDirectory'));
export const GameExtendedRules = universal(() => import('./GameExtendedRules'));
export const GameRules = universal(() => import('./GameRules'));
export const GameInfo = universal(() => import('./GameInfo'));
export const GetApp = universal(() => import('./GetApp'));
export const HeaderText = universal(() => import('./HeaderText'));
export const Hero = universal(() => import('./Hero'));
export const HighlightedCallout = universal(() =>
  import('./HighlightedCallout')
);
export const HighlightedRow = universal(() => import('./HighlightedRow'));
export const HowItWorks = universal(() => import('./HowItWorks'));
export const HowTo = universal(() => import('./HowTo'));
export const HowToPlay = universal(() => import('./HowToPlay'));
export const Integrations = universal(() => import('./Integrations'));
export const InterpolatedString = universal(() =>
  import('./InterpolatedString')
);
export const InviteFriends = universal(() => import('./InviteFriends'));
export const JobPostings = universal(() => import('./JobPostings'));
export const LearnMore = universal(() => import('./LearnMore'));
export const ListSignup = universal(() => import('./ListSignup'));
export const MembershipDetails = universal(() => import('./MembershipDetails'));
export const MembershipOffer = universal(() => import('./MembershipOffer'));
export const MembershipRules = universal(() => import('./MembershipRules'));
export const MembershipRulesArchive = universal(() =>
  import('./MembershipRulesArchive')
);
export const ModalLink = universal(() => import('./ModalLink'));
export const ParagraphText = universal(() => import('./ParagraphText'));
export const PartitionedCallout = universal(() =>
  import('./PartitionedCallout')
);
export const PaybetSuccess = universal(() => import('./PaybetSuccess'));
export const PlainContent = universal(() => import('./PlainContent'));
export const PressLogos = universal(() => import('./PressLogos'));
export const ProductHero = universal(() => import('./ProductHero'));
export const Questions = universal(() => import('./Questions'));
export const ResponsiveHeroImage = universal(() =>
  import('./ResponsiveHeroImage')
);
export const SimpleCta = universal(() => import('./SimpleCta'));
export const SimpleGameCta = universal(() => import('./SimpleGameCta'));
export const SocialFeed = universal(() => import('./SocialFeed'));
export const Stats = universal(() => import('./Stats'));
export const StepGroup = universal(() => import('./StepGroup'));
export const SvgIcon = universal(() => import('./SvgIcon'));
export const TestimonialCarousel = universal(() =>
  import('./TestimonialCarousel')
);
export const TestimonialFeature = universal(() =>
  import('./TestimonialFeature')
);
export const Testimonials = universal(() => import('./Testimonials'));
export const UpcomingGames = universal(() => import('./UpcomingGames'));
export const UserProfile = universal(() => import('./UserProfile'));
export const WaybetterWay = universal(() => import('./WaybetterWay'));
export const WorksWith = universal(() => import('./WorksWith'));

export const ExpandableContent = universal(() => import('./ExpandableContent'));

export { RowContext } from './RowContext.js';
